module.exports = __webpack_public_path__ + "static/media/運土紀錄表.bbfa6b25.xlsx";